import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { FloatLabel } from 'primereact/floatlabel';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { propTypes } from 'react-bootstrap/esm/Image';


export default function CityCombo(props) {
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [loadingProvince, setLoadingProvince] = useState(false);
    const [loadingCity, setLoadingCity] = useState(false);
    const [isFirstTime, setIsFirstTime] = useState(true);
    const [province, setProvince] = useState(null);
    const [city, setCity] = useState(null);
    const [provinceLoaded, setProvinceLoaded] = useState(false);
    const [cityLoaded, setCityLoaded] = useState(false);

    useEffect(() => {
        if(provinceLoaded){
            if(props.value){
                if(props.value != null){
                    if(props.value.provinceId>0){
                        var p = getProvince(provinces, props.value.provinceId);
                        setProvince(p); 
                        console.log("selected p is>", p);
                        if(props.value.provinceId == province.id){
                            var c = getCity(cities, props.value.cityId);
                            setCity(c);
                        }   
                        else{                      
                            onProvinceChanged(p);
                        }
                    }
                }
            }
            return;
        }
        setLoadingProvince(true);
        var params = {param1:"", param2:"", param3:"", param4:"", param5:""};
        var url = config.Server+`/basic/province/list`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setProvinces(response);
                setLoadingProvince(false);
                setProvinceLoaded(true);
                if(props.value){
                    if(props.value != null){
                        if(props.value.provinceId>0){
                            var p = getProvince(response, props.value.provinceId);
                            setProvince(p); 
                            console.log("selected p is>", p)                           
                            onProvinceChanged(p);
                            setIsFirstTime(false);
                        }
                    }
                }
            }
            else{
                console.log("error is>", response.message)
            }
        })
        .catch(error => {
            console.log("error is>", error)
        });
    }, [props.value]);
    const getProvince = function(items, id){
        if(items == null) return null;
        for(var i=0;i<items.length;i++){
            if(items[i].id == id) return items[i];
        }
        return null;
    }
    const getCity = function(items, id){
        if(items == null) return null;
        for(var i=0;i<items.length;i++){
            if(items[i].cityId == id) return items[i];
        }
        return null;
    }

    const onProvinceChanged = function (p){
        if(p == null){
            setCities([]);
            setCity(null);
            if(props.onChange) {
                setIsFirstTime(true);
                props.onChange(null);
            }
            return;
        }
        setLoadingCity(true);
        var params = {param1:String(p.id), param2:"", param3:"", param4:"", param5:""};
        var url = config.Server+`/basic/city/list`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("resopnse is> ", response);
                setCities(response);
                if(props.value){
                    if(props.value != null){
                        if(props.value.cityId>0){
                            var c = getCity(response, props.value.cityId);
                            setCity(c);
                            if(!isFirstTime){
                                if(props.onChange) {
                                    setIsFirstTime(true);
                                    props.onChange(c);
                                }
                            }
                        }
                    }
                }
                setLoadingCity(false);
            }
            else{
                console.log("error is>", response.message)
            }
        })
        .catch(error => {
            console.log("error is>", error)
        });
    }
    const onCityChanged = function (c){
        if(!c) c = null;
        if(props.onChange){
            setIsFirstTime(true);
            props.onChange(c);
        }
    }


    return(
        <>
        {
            props.horizontal === true?
            <Row style={{direction:"rtl"}}>
                <Col md={6} style={{marginTop:"20px"}}>
                    <div className="card flex justify-content-center" style={{direction:"ltr"}}>
                        <FloatLabel className="w-full md:w-14rem">
                            <Dropdown inputId="province" value={province} onChange={(e) => {setCityLoaded(false); setProvince(e.value); onProvinceChanged(e.value);}} options={provinces} optionLabel="title" className="w-full" 
                             checkmark={true} highlightOnSelect={true} filter showClear  style={{width:"100%"}} loading={loadingProvince}  scrollHeight="350px"  
                            />
                            <label htmlFor="province">استان</label>
                        </FloatLabel>
                    </div>
                </Col>
                <Col md={6} style={{marginTop:"20px"}} >
                    <div className="card flex justify-content-center" style={{direction:"ltr"}}>
                        <FloatLabel className="w-full md:w-14rem">
                            <Dropdown inputId="city" value={city} onChange={(e) => {setCity(e.value); onCityChanged(e.value);}} options={cities} optionLabel="title" className="w-full" 
                             checkmark={true} highlightOnSelect={true} filter showClear  style={{width:"100%"}} loading={loadingProvince} scrollHeight="350px"    
                            />
                            <label htmlFor="city">شهر</label>
                        </FloatLabel>
                    </div>
                </Col>
            </Row>
            :
            <>
            <Row>
                <Col>
                    <div className="card flex justify-content-center">
                        <FloatLabel className="w-full md:w-14rem">
                            <Dropdown inputId="province" value={province} onChange={(e) => {setProvince(e.value); onProvinceChanged(e.value);}} options={provinces} optionLabel="title" className="w-full" 
                             checkmark={true} highlightOnSelect={true} filter showClear  style={{width:"100%"}} loading={loadingProvince}  scrollHeight="350px"  
                            />
                            <label htmlFor="province">استان</label>
                        </FloatLabel>
                    </div>
                    
                </Col>
            </Row>
            <Row style={{marginTop:"20px"}}>
                <Col>
                    <div className="card flex justify-content-center">
                        <FloatLabel className="w-full md:w-14rem">
                            <Dropdown inputId="city" value={city} onChange={(e) => {setCity(e.value); onCityChanged(e.value);}} options={cities} optionLabel="title" className="w-full" 
                             checkmark={true} highlightOnSelect={true} filter showClear  style={{width:"100%"}} loading={loadingProvince} scrollHeight="350px"    
                            />
                            <label htmlFor="city">شهر</label>
                        </FloatLabel>
                    </div>
                    
                </Col>
            </Row>
            </>
        }
        </>
    )
}